import { GraphQLCall, validatedResponse } from "./helper";
import { getDeviceListOfPartnerListQuery, getDeviceListForCareTeamListQuery } from "./graphQl/queries";

export const getGQLDeviceList = async (orgId) => {
    try {
        const data = await GraphQLCall(
            getDeviceListOfPartnerListQuery,
            { limit: 100, offset: 0, partnerId: orgId }
        );

        const validatedData = validatedResponse("getDeviceListOfPartner", data);
        return validatedData;
    } catch (error) {
        console.error("Error while fetching patient list:", error.message);
        throw error;
    }
};

export const getGQLDeviceListForCareTeam = async (userId) => {
    try {
        const data = await GraphQLCall(
            getDeviceListForCareTeamListQuery,
            { limit: 100, offset: 0, userCredId: userId }
        );

        const validatedData = validatedResponse("getDeviceListForCareTeam", data);
        return validatedData;
    } catch (error) {
        console.error("Error while fetching patient list:", error.message);
        throw error;
    }
};